module.exports = __webpack_public_path__ + "img/anina-coetzee.7ed68e1c.svg";